"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCOUNTING_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCOUNTING_INTEGRATION;
  }
});
Object.defineProperty(exports, "AUTO_TAX_PAYMENTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTO_TAX_PAYMENTS;
  }
});
Object.defineProperty(exports, "BENEFITS_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BENEFITS_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CORE_HR_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CORE_HR_INTEGRATION;
  }
});
Object.defineProperty(exports, "DIRECT_DEPOSIT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DIRECT_DEPOSIT;
  }
});
Object.defineProperty(exports, "EXPENSE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EXPENSE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "LEAVE_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LEAVE_TRACKING;
  }
});
Object.defineProperty(exports, "MOBILE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MOBILE;
  }
});
Object.defineProperty(exports, "PAYROLL_ENTRY", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PAYROLL_ENTRY;
  }
});
Object.defineProperty(exports, "RECORD_KEEPING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.RECORD_KEEPING;
  }
});
Object.defineProperty(exports, "REPORTING_DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REPORTING_DASHBOARDS;
  }
});
Object.defineProperty(exports, "TAX_CALCS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TAX_CALCS;
  }
});
Object.defineProperty(exports, "TAX_FILING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TAX_FILING;
  }
});
Object.defineProperty(exports, "TIME_ATTENDENCE_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TIME_ATTENDENCE_TRACKING;
  }
});
Object.defineProperty(exports, "TIME_TRACKING_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TIME_TRACKING_INTEGRATION;
  }
});
Object.defineProperty(exports, "WEB_PORTAL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WEB_PORTAL;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Payroll.js
// module id = 576
// module chunks = 209 210 211 212 213